import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.css'],
})
export class ReleaseNotesComponent implements OnInit {
  @Input() releaseNote:string;
  @Input() internalReleaseNote:string;
  @Input() isSuperUser: boolean = false;

  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit(): void {
   //this is intensional
  }

  OnClose() {
    this.activeModal.dismiss('Cross click');
  }
}
